import { useState } from 'react';
import type { AssignUserRoleRequest, AssignUserRoleResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * Direct Pattern hook for assigning a Role to a user.
 * Hits POST /account/user-roles/assign. Returns 409 if the user already has
 * the role; the caller can treat that as a no-op for multi-select flows.
 */
export default function useAssignUserRole() {
  const [submitting, setSubmitting] = useState(false);

  async function assignUserRole(
    params: AssignUserRoleRequest,
    bearer?: string,
  ): Promise<AssignUserRoleResponse> {
    try {
      setSubmitting(true);
      const res = await api.postAssignUserRole(params, undefined, bearer);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (error) {
      console.error('Assign user role failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, assignUserRole };
}
